import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_BASKETS_APP_PATHS } from '../constants/baskets-app-paths.constants';
import AdminBasketsView from '../views/admin/AdminBaskets.view';
import AdminBasketDetailsView from '../views/admin/AdminBasketDetails.view';

export default function AdminBasketsRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_BASKETS_APP_PATHS.BASKETS_LIST} component={AdminBasketsView} />
      <Route exact path={ADMIN_BASKETS_APP_PATHS.BASKET_DETAILS(':basketId')} component={AdminBasketDetailsView} />
    </React.Fragment>
  );
}
